import PendingApprovalAdviserProfilesApi from '../../../core/api/PendingApprovalAdviserProfilesApi'
const api = new PendingApprovalAdviserProfilesApi()

export const FETCHED_PENDING_APPOVAL_PROFILES = 'FETCHED_PENDING_APPOVAL_PROFILES'

export const events = {
  fetching: {
    pendingApprovalProfiles: 'FETCHING_PENDING_APPOVAL_PROFILES'
  },
  fetched: {
    pendingApprovalProfiles: 'FETCHED_PENDING_APPOVAL_PROFILES'
  },
  set: {
    searchTerm: 'SET_SEARCH_TERM',
    filter: 'SET_FILTER',
    page: 'SET_PAGE'
  }
}

const fetchingPendingApprovalProfiles = (page) => ({
  type: events.fetching.pendingApprovalProfiles
})

function fetchPendingApprovalProfiles (searchTerm, currentPage, pageSize, filter, orderBy, sortAscending) {
  const pendingApprovalProfilesRequest = api.getPendingApprovalProfiles(searchTerm, currentPage, pageSize, filter, orderBy, sortAscending)

  return (dispatch) => {
    dispatch(fetchingPendingApprovalProfiles())
    pendingApprovalProfilesRequest.then(function (response) {
      dispatch(api.handleResponse(events.fetched.pendingApprovalProfiles, response))
    })
  }
}

export const actions = {
  fetch: {
    pendingApprovalProfiles: fetchPendingApprovalProfiles
  },
  set: {
    searchTerm: (searchTerm) => ({ type: events.set.searchTerm, searchTerm }),
    filter: (filter) => ({ type: events.set.filter, filter }),
    page: (page) => ({ type: events.set.page, page })
  }
}
